import BaseView from './BaseView';
import '@lottiefiles/lottie-player';
let view = null;

class Error404 extends BaseView {
	constructor(container) {
		super(container);

		this.init();
	}

	init() {
		document.body.classList.add('body--inverted');
	}
}

export default {
	namespace: '404',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Error404(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
